@import '../../../utils/global.module.less';

.warning_big {
    font-family: 'Hanken Grotesk';
    font-size: 26px;
    font-weight: 600;
    color: @title-color;
    margin-bottom: 10px;
    text-align: center;
}
.warning_big_target {
    .warning_big();
    color: rgb(221, 59, 59) !important;
    font-size: 28px !important;
}

.warning_small {
    text-align: center;
    font-family: 'Hanken Grotesk';
    font-size: 18px;
    font-weight: 400;
    color: @title-color;
}

.warning_svg {
    height: 100px;
    margin: 0px 0px 20px 0px;
}

.seperator {
    width: 100%;
    height: 1px;
    background-color: #e3e6eb;
    margin: 0px 0;
    margin-bottom: 20px;
}

.cancelButton {
    .baseNoButton();
}

.confirmButton {
    .baseYesButtonStyle();
    background-color: #e11a32 !important;

    &:hover {
        background-color: #cf192e !important;
    }

    &:active {
        background-color: #e11a32 !important;
    }
}
